import script from "./index.vue?vue&type=script&lang=ts&setup=true"
export * from "./index.vue?vue&type=script&lang=ts&setup=true"

import "./index.vue?vue&type=style&index=0&id=6c67f9c2&lang=less&scoped=true"

import exportComponent from "C:\\Users\\bruce\\Desktop\\优海项目\\新git仓库\\uhi_hik_dock\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c67f9c2"]])

export default __exports__